import { Component, OnInit } from '@angular/core';
import { LayoutService } from "./service/app.layout.service";
import { UtilityFunctionService } from '../service/utility-function.service';

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html'
})
export class AppFooterComponent implements OnInit {
    currentTimestamp!: string;

    constructor(public layoutService: LayoutService, public utilityService: UtilityFunctionService) { }

    ngOnInit() {
        // Initialize timestamp once to prevent change detection errors
        this.currentTimestamp = this.utilityService.resultTime ?? this.utilityService.getESTDateTime();
    }
}
